import { HomeComponent } from './../components/home/home.component';
import { NgModule } from '@angular/core';
import { RouterModule, Routes, PreloadAllModules } from '@angular/router';
import { PageSettingsComponent } from '../components/pages/page-settings/page-settings.component';
import { PageDashboardComponent } from '../components/pages/page-dashboard/page-dashboard.component';
import { GuardService } from 'src/app/services/guard/guardService.service';
import { ProtocolGuardService } from '../services/guard/protocol-guard.service';
import { FeatureGuardService } from '../services/guard/feature-guard.service';

const routes: Routes = [
	{
		path: '',
		canActivateChild: [FeatureGuardService],
		children: [
			{
				path: 'dashboard',
				component: PageDashboardComponent,
				canDeactivate: [GuardService],
				canActivate: [GuardService],
				data: {
					pageName: 'Dashboard',
					pageTag: 'dashboard',
				},
			},
			{
				path: 'device',
				loadChildren: () =>
					import('./hardware-settings/hardware-settings.module').then(
						(m) => m.HardwareSettingsModule
					),
				data: {
					categoryTag: 'device',
				},
			},
			{
				path: 'settings',
				component: PageSettingsComponent,
				data: {
					pageName: 'Page.Settings',
					categoryTag: 'user',
					pageTag: 'preferenceSetting',
				},
			},
			{
				path: 'wifi-security',
				loadChildren: () =>
					import('./wifi-security/wifi-security.module').then(
						(m) => m.WiFiSecurityModule
					),
			},
			{
				path: 'support',
				loadChildren: () => import('./support/support.module').then((m) => m.SupportModule),
			},
			{
				path: 'hardware-scan',
				loadChildren: () =>
					import('./hardware-scan/hardware-scan.module').then(
						(m) => m.HardwareScanModule
					),
			},
			{
				path: 'snapshot',
				loadChildren: () =>
					import('./snapshot/snapshot.module').then((m) => m.SnapshotModule),
			},
			{
				path: '**',
				canActivate: [ProtocolGuardService],
				component: HomeComponent,
			},
		],
	},
];

@NgModule({
	imports: [
		RouterModule.forRoot(routes, {
			useHash: true,
			scrollPositionRestoration: 'enabled',
			enableTracing: false,
			preloadingStrategy: PreloadAllModules,
			relativeLinkResolution: 'legacy',
		}),
	],
	exports: [RouterModule],
})
export class AppRoutingModule {}
